import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const savedLanguage =
  localStorage.getItem("language") || navigator.language.split("-")?.[0];

i18n
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: savedLanguage,
    debug: true,

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

export default i18n;
